import React from 'react';
import '../../css/vers2/ExchangeSection.css';

type ExchangeSectionProps = {
    setPage: React.Dispatch<React.SetStateAction<string>>;
};

const ExchangeSection = ({ setPage }: ExchangeSectionProps) => {
    return (
        <section id="ruildagen" className="exchange-scene">
            <img className="exchange-creature jelly-top" src="/icons/exchange/octoTop.png" alt="" />
            <img className="exchange-creature starfish" src="/icons/exchange/star.png" alt="" />
            <img className="exchange-creature octopus" src="/icons/exchange/purpleBlob.png" alt="" />
            <img className="exchange-creature jelly-bottom" src="/icons/exchange/octoBttm.png" alt="" />

            <div className="exchange-box box-ruildagen">
                <h2>Ruildagen</h2>
                <p>Ruilen van de dagen is toegestaan, mits het maximale aantal kinderen niet wordt overschreden.</p>
            </div>

            <h2 className="exchange-outline-title">Zelf mee te nemen door de vraagouder</h2>

            <ol className="exchange-bring-list">
                <li>Luiers</li>
                <li>Flesvoeding + fles</li>
                <li>Eventueel fruit- of groente hapjes</li>
                <li>Speciaal eten i.v.m. allergieën of dieet</li>
                <li>Knuffeltjes</li>
                <li>Speentje</li>
                <li>Setje reserve kleding</li>
            </ol>

            <div className="exchange-box box-wenmoment">
                <h2>Wenmoment</h2>
                <p>
                    Wennen wordt samen met u afgesproken. Dit is standaard een ochtend of middag en duurt 3 uurtjes.
                    Zo kunnen wij goed aan elkaar wennen dat uw kind bij mij is.
                </p>
                <p>Wilt u meer wenmomenten inplannen? Dan kan dat in overleg.</p>
                <p>Voor het 1e wenmoment worden er geen kosten in rekening gebracht. De keren daarna wel.</p>
            </div>
        </section>
    );
};

export default ExchangeSection;
